import React from 'react'
import { PublicLayout } from 'app/livbrite/components/PublicLayout'
import { FadeIn } from 'lib/ui/components'
import { Results } from './components/Results'
import { useHistory } from 'react-router-dom'

interface Props {
  location: {
    state: {
      results: any[]
    }
  }
}

export const WellnessSurveyResults: React.FC<Props> = ({ location }) => {
  const history = useHistory()

  if (!location?.state?.results) {
    history.push('/wellness-survey')
    return null
  }

  return (
    <PublicLayout className='survey-results'>
      <FadeIn>
        <Results
          resultsData={location.state.results}
        />
      </FadeIn>
    </PublicLayout>

  )
}
